"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgCodepen = function SvgCodepen(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M13.391 28.294l.064.044A1 1 0 0113 27.5v-7a1 1 0 01.443-.831l.012-.007 10-6.5a1 1 0 011.09 0l10 6.5a1 1 0 01.274.265l.03.044a1 1 0 01.034.059l-.064-.103A.996.996 0 0135 20.5v7a1 1 0 01-.065.354l-.004.011a1 1 0 01-.134.24l.022-.032a1.002 1.002 0 01-.274.265l-10 6.5a1 1 0 01-1.09 0l-10-6.5-.012-.007a.992.992 0 01-.052-.037zM19 25.22l-3.213 2.249 7.227 4.699A1.007 1.007 0 0123 32v-3.5c0-.149.032-.29.09-.416L19 25.22zm10 0l-4.09 2.864c.058.127.09.267.09.416V32c0 .057-.005.113-.014.168l7.226-4.699L29 25.22zm-5-3.5L20.744 24 24 26.28 27.256 24 24 21.72zm9 .7l-2.256 1.579L33 25.579V22.42zm-18 .001v3.157l2.255-1.579L15 22.421zM25 16v3.979l4 2.8 3.212-2.249-7.226-4.698c.01.055.014.11.014.168zm-1.986-.168l-7.227 4.698 3.212 2.249 4-2.801L23 16c0-.057.005-.113.014-.168z",
    id: "codepen_svg__a"
  }));
};

var _default = SvgCodepen;
exports["default"] = _default;